import React from 'react'
import CityLogo from '../../img/city-logo-2.svg';
import SaEnkeltLogo from '../../img/sa-enkelt-logo.svg';

const { REACT_APP_BRAND } = process.env;


const AuthHeader = () => {
  return (
    <header className="login-header">
      {REACT_APP_BRAND === 'CITY'
        ? <img src={CityLogo} alt="City Logo" />
        : <img src={SaEnkeltLogo} alt="Sa Enkelt Logo" />
      }
    </header>
  )
}

export default AuthHeader
